import { nextTick } from "vue";
import { createWebHistory, createRouter } from "vue-router";
import MainLayout from "@/components/main_layout.vue";
import FlightsGrid from "@/components/flights/flights_grid.vue";
import i18n from "@/i18n";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      redirect: `/${i18n.global.locale}`,
    },
    {
      path: "/:locale",
      name: "main",
      component: MainLayout,
      children: [
        {
          path: "time-sheets",
          name: "main.timeSheet",
          component: FlightsGrid,
          props: (route) => ({ startHoleFilter: route.query.startHole * 1 }),
        },
      ],
    },
  ],
});

// USE FOR AUTH STUFF
router.beforeEach(async (to, from, next) => {
  if (to.params.locale === from.params.locale) {
    next();
    return;
  }

  const { locale } = to.params;
  i18n.global.locale = locale;

  next();
});

router.afterEach((to) => {
  nextTick(() => {
    document.title = to.meta.title || i18n.global.t("title");
  });
});

export default router;
